<template>
  <div class="container pb-5">
    <legend>Неактивные партнеры</legend>
    <table class="table table-hover table-bordered table-sm">
      <thead>
      <tr>
        <th>Объезд</th>
        <th>Пункт</th>
        <th>Телефон</th>
        <th>Долг</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items">
        <td>{{item.TourName}}</td>
        <td>
          <router-link :to="{ name: 'partner', params: {id: item.CustomerId}}"
                       target="_blank">
            {{item.Reception}}
          </router-link>
          </td>
        <td>{{item.UserPhone}} {{item.DirectorPhone}}</td>
        <td>{{pointDebt[item.Id]}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { get, post } from '@/admin/services/api/http-utils';
import _ from 'lodash';

const url = `${process.env.VUE_APP_API_HOST}admin/customer`;

export default {
  data() {
    return {
      items: [],
      pointDebt: [],
    };
  },
  async mounted() {
    await this.fetchItems();
    await this.fetchPointDebt();
  },
  methods: {
    async fetchItems() {
      const { data } = await get(`${url}/inactive-customers`);
      this.items = data;
    },
    async fetchPointDebt() {
      const pointIds = _.map(this.items, p => p.Id);
      const { data } = await post(`${process.env.VUE_APP_API_HOST}admin/delivery/point-debt`, { pointIds });
      this.pointDebt = data;
    },
  },
};
</script>
